import React from 'react';
import { LocationMap, LocationTypes } from '../../../../sitewide';

export const Map = (locationMapProps: LocationTypes.ILocationMap) => {
  return (
    <div className="heroMapContainer is-cp-w-100">
      <LocationMap {...locationMapProps} variant="cover-image" />
    </div>
  );
};
